var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import { User } from '@/models/User';
import LinkParnassysDialog from '@/components/dialog-parnassys-link/DialogParnassysLink';
import { RolesEnum } from '@/items/Roles';
let Parnassys = class Parnassys extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Parnassys';
        this.isLinkingUser = false;
        this.userToLink = null;
    }
    mounted() {
        //
    }
    refreshDataTable() {
        this.datatable && this.datatable.refresh();
    }
    get datatable() {
        if (!(this.$refs && this.$refs.parnassysDataTable)) {
            return null;
        }
        return this.$refs.parnassysDataTable;
    }
    get tableVisibilityOptions() {
        return {
            checkboxes: false,
            search: false,
        };
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('parnassys.table.results_found', 1),
                plural: this.$tc('parnassys.table.results_found', 2),
            },
            headers: [
                {
                    text: this.$t('parnassys.table.headers.name').toString(),
                    value: 'name',
                },
                {
                    text: this.$t('parnassys.table.headers.roles').toString(),
                    value: 'rolesLabel',
                    transform: (name) => (this.$tc(`group.${name.toLocaleLowerCase()}`, 1)),
                },
                {
                    text: this.$t('parnassys.table.headers.parnassys_id').toString(),
                    value: 'parnassys_id',
                    sortable: {
                        key: 'parnassys_id',
                        order: 'ASC',
                    },
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: this.$t('parnassys.table.headers.name').toString(),
                    icon: 'link',
                    action: (vm, user) => {
                        this.userToLink = user;
                        this.isLinkingUser = true;
                    },
                    roles: [RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER],
                },
            ],
            filters: [],
            model: new User().include('roles').filter({ roles: [RolesEnum.STUDENT, RolesEnum.GUARDIAN, RolesEnum.TEACHER] }),
        };
    }
};
Parnassys = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            LinkParnassysDialog,
        },
    })
], Parnassys);
export default Parnassys;
